import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState, useMemo } from 'react';
import ajax from '@/scripts/ajax';
import { SEARCH_ITEM_COL, SEARCH_ITEM_GUTTER } from '@/scripts/config';
import { useGetAreaQuery, useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import dayjs from 'dayjs';
import LabelValueAutoComplete from '@/components/common/LabelValueAutoComplete';
import {
    Button,
    Input,
    Card,
    Form,
    Typography,
    Space,
    Modal,
    Checkbox,
    Popover,
    DatePicker,
    message,
    InputNumber,
    Popconfirm,
    Select,
    Col,
    Row,
    Table,
    AutoComplete,
} from 'antd';
import { getLabelFromMap, createJsonOptions } from '@/scripts/utils';
import { Right } from '@icon-park/react';
import { number } from 'bfj/src/events';
const pageKey = 'BookTaskList'; //页面身份

const COLUMN_VISIBLE_COOKIE_KEY = 'BookTaskList_visible_columns';
// 设置 Cookie
const setCookie = (name: string, value: string, days: number = 365) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
};

// 获取 Cookie
const getCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
};
export default function BookTaskList() {
    const [dataSource, setData] = useState([]);
    // const [deVal, setDeVal] = useState([]);
    // const [pageKey, setPageKey] = useState(pageKey);
    const [form] = Form.useForm();
    const [newForm] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const [pageSize, setSize] = useState(100);
    const [total, setTotal] = useState(0);
    const [current, setPage] = useState(1);
    const { data: startPortOptions } = useGetStartPortQuery(0);
    const { data: endPortOptions } = useGetEndPortQuery(0);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formSearch] = Form.useForm();
    const [promptText, setPromptText] = useState([]);
    const [hostOptions, setOptions] = useState([]);
    const [tableScrollY, setTableScrollY] = useState(600);
    const ALL_COLUMN_KEYS = [
        'id',
        'order_id',
        'account_name',
        'quantity',
        'box_type',
        'origincity_name',
        'destinationcity_name',
        'destination_service_mode',
        'order_date',
        'is_USA',
        'route_select',
        'is_order',
        'limit_price',
        'is_plan',
        'is_roll',
        'cid',
        'is_cid',
        'fake_account',
        'update_cid_time',
        'cid_type',
        'cid_loop_times',
        'get_cid_times',
        'cid_concurrent',
        'cid_sleep',
        'nac_loop_times',
        'nac_times',
        'nac_concurrent',
        'nac_sleep',
        'limit_day',
        'cid_group',
        'group_id',
        'booking_number',
        'operation',
    ];
    const getInitialVisibleColumns = () => {
        const cookieValue = getCookie(COLUMN_VISIBLE_COOKIE_KEY);
        if (cookieValue) {
            try {
                const saved = JSON.parse(cookieValue);
                // 过滤掉可能已不存在的列 key（防止新增/删除列时出错）
                if (Array.isArray(saved) && saved.length > 0) {
                    return saved.filter(key => ALL_COLUMN_KEYS.includes(key));
                }
            } catch (e) {
                console.error('解析列设置 Cookie 失败', e);
            }
        }
        return ALL_COLUMN_KEYS;
    };

    // 控制可见列
    const [visibleColumnKeys, setVisibleColumnKeys] = useState(getInitialVisibleColumns);
    const [columnSettingVisible, setColumnSettingVisible] = useState(false);
    const updateVisibleColumns = (keys: string[]) => {
        setVisibleColumnKeys(keys);
        setCookie(COLUMN_VISIBLE_COOKIE_KEY, JSON.stringify(keys));
    };
    const FIELD_MAP = {
        is_order: { 0: '关闭', 1: '开启' },
        is_USA: { 0: '否', 1: '是' },
        is_plan: { 0: '否', 1: '是' },
        is_roll: { 0: '否', 1: '是' },
        is_cid: { 0: '关闭', 1: '常规初始化', 2: '加载更多初始化' },
        cid_type: { 0: '常规下单', 1: '模式下单', 2: '模式下单2', 3: '模式下单3', 4: '模式下单4' },
    };

    const refreshList = () => {
        renderSearch({ current, pageSize });
    };

    useEffect(() => {
        refreshList();
        const updateHeight = () => {
            const windowHeight = window.innerHeight;
            setTableScrollY(windowHeight - 400); // 减去顶部/底部元素高度
        };
        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    const save = async (record) => {
        try {
            const changedFields = await form.validateFields();
            const originalRecord = dataSource.find((item) => item.id === record.id);
            if (!originalRecord) {
                throw new Error('记录不存在');
            }
            const updatedData = { ...originalRecord, ...changedFields };

            // 处理日期：YYYY-MM-DD
            if (updatedData.order_date && dayjs.isDayjs(updatedData.order_date)) {
                updatedData.order_date = updatedData.order_date.format('YYYY-MM-DD');
            }

            if (Array.isArray(updatedData.quantity)) {
                updatedData.quantity = updatedData.quantity.join(',');
            }
            if (Array.isArray(updatedData.box_type)) {
                updatedData.box_type = updatedData.box_type.join(',');
            }

            const params = { ...updatedData, id: record.id };

            await ajax.post('/maersk/book/task', params);
            message.success('保存成功');
            refreshList();
            setEditingKey('');
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };
    // 切换状态的函数
    const toggleOrderStatus = (id, currentValue) => {
        const newValue = currentValue === 1 ? 0 : 1;
        const params = { ids: id.toString(), is_order: newValue };
        ajax.post('/maersk/group/task', params)
            .then(() => {
                message.success(`${newValue === 1 ? '开启' : '关闭'}成功`);
                refreshList();
            })
            .catch((err) => console.log(err));
    };

    const EditableCell = React.memo(
        ({
            editing,
            inputType,
            dataIndex,
            title,
            inputTypeBox,
            inputTypeStart,
            inputTypeEnd,
            serviceMode,
            openTypeSelect,
            PlanSelect,
            RollSelect,
            openTypeUSA,
            CIDTypeSelect,
            CIDSelect,
            record,
            index,
            children,
            inputTypeDate,
            isOrderColumn,
            ...restProps
        }) => {
            let inputNode;

            // 先检查是否为数字输入
            if (inputType === 'number') {
                inputNode = <InputNumber />;
            } else if (openTypeSelect === 'select') {
                inputNode = (
                    <Select
                        style={{ width: 80 }}
                        options={[
                            { label: '开启', value: 1 },
                            { label: '关闭', value: 0 },
                        ]}
                        showSearch
                        allowClear
                    />
                );
            } else if (PlanSelect === 'select') {
                inputNode = (
                    <Select
                        style={{ width: 80 }}
                        options={[
                            { label: '是', value: 1 },
                            { label: '否', value: 0 },
                        ]}
                        showSearch
                        allowClear
                    />
                );
            } else if (RollSelect === 'select') {
                inputNode = (
                    <Select
                        style={{ width: 80 }}
                        options={[
                            { label: '是', value: 1 },
                            { label: '否', value: 0 },
                        ]}
                        showSearch
                        allowClear
                    ></Select>
                );
            } else if (openTypeUSA === 'select') {
                inputNode = (
                    <Select
                        style={{ width: 80 }}
                        options={[
                            { label: '是', value: 1 },
                            { label: '否', value: 0 },
                        ]}
                        showSearch
                        allowClear
                    ></Select>
                );
            } else if (CIDTypeSelect === 'select') {
                inputNode = (
                    <Select
                        style={{ width: 80 }}
                        options={[
                            { label: '关闭', value: 0 },
                            { label: '常规初始化', value: 1 },
                            { label: '加载更多初始化', value: 2 },
                            { label: '3', value: 3 },
                            { label: '4', value: 4 },
                        ]}
                        showSearch
                        allowClear
                    ></Select>
                );
            } else if (CIDSelect === 'select') {
                inputNode = (
                    // <Select
                    //     style={{ width: 120 }}
                    //     options={[
                    //         { label: '常规下单', value: 0 },
                    //         { label: '模式下单', value: 1 },
                    //         { label: '模式下单2', value: 2 },
                    //         { label: '模式下单3', value: 3 },
                    //         { label: '模式下单4', value: 4 },
                    //     ]}
                    //     showSearch
                    //     allowClear
                    // ></Select>
                    <LabelValueAutoComplete
                        style={{ width: '100%' }}
                        options={cidTypeOptions}
                        placeholder="选择或输入"
                        allowClear
                        showSearch
                    />

                );
            } else if (inputTypeBox === 'select') {
                inputNode = (
                    <Select
                        style={{ width: 80 }}
                        options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                        showSearch
                        allowClear
                    ></Select>
                );
            } else if (inputTypeStart === 'select') {
                inputNode = <Select style={{ width: 160 }} options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>;
            } else if (inputTypeEnd === 'select') {
                inputNode = <Select style={{ width: 160 }} options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>;
            } else if (serviceMode === 'select') {
                inputNode = <Select style={{ width: 80 }} options={createJsonOptions(['CY', 'SD'])} showSearch allowClear></Select>;
            } else if (inputTypeDate === 'date') {
                inputNode = <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />;
            } else {
                // 默认输入框
                inputNode = <Input />;
            }
            if (dataIndex === 'quantity') {
                inputNode = (
                    <Select
                        mode="tags"
                        tokenSeparators={[',', ' ', '\n']}
                        maxTagCount={1}
                        onKeyDown={(e) => {
                            const key = e.key;
                            if (
                                !/^[0-9]$/.test(key) &&
                                key !== 'Backspace' &&
                                key !== 'Delete' &&
                                key !== 'ArrowLeft' &&
                                key !== 'ArrowRight' &&
                                key !== 'Tab' &&
                                key !== 'Enter' &&
                                key !== ',' &&
                                key !== ' ' &&
                                key !== ';'
                            ) {
                                e.preventDefault();
                            }
                        }}

                        style={{ width: '100%' }}
                    />
                );
            } else if (dataIndex === 'box_type') {
                inputNode = (
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        maxTagCount={1}
                        options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                        showSearch
                        allowClear
                    />
                );
            }
            return (
                <td
                    onClick={(e) => {
                        if (isOrderColumn && !editing) {
                            e.stopPropagation();
                            const currentValue = record[dataIndex]; // 数字 0/1
                            toggleOrderStatus(record.id, currentValue);
                        }
                    }}
                    style={{
                        cursor: isOrderColumn && !editing ? 'pointer' : 'default',
                        position: 'relative',
                    }}
                    {...restProps}>
                    {editing ? (
                        <Form.Item
                            name={dataIndex}
                            style={{
                                margin: 0,
                            }}
                        >
                            {inputNode}
                        </Form.Item>
                    ) : // 非编辑态时，如果是“是否开启”列，为单元格文字增加边框样式
                        isOrderColumn ? (
                            <span
                                style={{
                                    display: 'inline-block',
                                    padding: '2px 6px',
                                    border: '1px solid #bbb5b5ff',
                                    borderRadius: 4,
                                    lineHeight: '20px',
                                    userSelect: 'none',
                                    width: '48px',
                                    textAlign: 'center',
                                }}
                            >
                                {children}
                            </span>
                        ) : (
                            children
                        )}
                </td>
            );
        },
    );

    const isEditing = (record) => record.id === editingKey;

    const onChange = (val) => {
        form.setFieldsValue({
            order_date: dayjs(val).format('YYYY-MM-DD'),
        });
    };

    const edit = (record) => {
        try {
            const formValues = { ...record };
            if (formValues.order_date) {
                const d = dayjs(formValues.order_date);
                formValues.order_date = d.isValid() ? d : null;
            } else {
                formValues.order_date = null;
            }
            if (formValues.quantity && typeof formValues.quantity === 'string') {
                formValues.quantity = formValues.quantity.split(',').filter(Boolean);
            }
            if (formValues.box_type && typeof formValues.box_type === 'string') {
                formValues.box_type = formValues.box_type.split(',').filter(Boolean);
            }
            form.setFieldsValue(formValues);
            setEditingKey(record.id);
        } catch (error) {
            console.error('Edit error:', error);
        }
    };
    const cidTypeOptions = [
        { label: '常规下单', value: 0 },
        { label: '模式下单', value: 1 },
        { label: '模式下单2', value: 2 },
        { label: '模式下单3', value: 3 },
        { label: '模式下单4', value: 4 },
    ];
    const columns = useMemo(
        () => [
            {
                title: 'ID',
                dataIndex: 'id',
                width: 80,
                key: 'id',
                // sorter: (a, b) => a?.id - b?.id,
            },
            {
                title: '对应taskID',
                dataIndex: 'order_id',
                width: 120,
                editable: true,
                key: 'order_id',
                // sorter: (a, b) => a?.order_id - b?.order_id,
            },
            {
                title: '账户名',
                dataIndex: 'account_name',
                width: 150,
                editable: true,
                key: 'account_name',
                sorter: (a, b) => a['account_name'].localeCompare(b['account_name']),
            },
            {
                title: '数量',
                dataIndex: 'quantity',
                width: 100,
                editable: true,
                key: 'quantity',
                sorter: (a, b) => a?.quantity - b?.quantity,
            },
            {
                title: '箱型',
                dataIndex: 'box_type',
                width: 100,
                editable: true,
                key: 'box_type',
                sorter: (a, b) => a['box_type'].localeCompare(b['box_type']),
            },
            {
                title: '起始港',
                dataIndex: 'origincity_name',
                width: 180,
                editable: true,
                key: 'origincity_name',
                sorter: (a, b) => a['origincity_name'].localeCompare(b['origincity_name']),
            },
            {
                title: '目的港',
                dataIndex: 'destinationcity_name',
                width: 180,
                editable: true,
                key: 'destinationcity_name',
                sorter: (a, b) => a['destinationcity_name'].localeCompare(b['destinationcity_name']),
            },
            {
                title: '目的港类型',
                dataIndex: 'destination_service_mode',
                width: 100,
                editable: true,
                key: 'destination_service_mode',
                sorter: (a, b) => a['destination_service_mode'].localeCompare(b['destination_service_mode']),
            },
            {
                title: '搜索开航日',
                dataIndex: 'order_date',
                width: 150,
                editable: true,
                key: 'order_date',
                sorter: (a, b) => a['order_date'].localeCompare(b['order_date']),
            },
            {
                title: '美线',
                dataIndex: 'is_USA',
                width: 100,
                editable: true,
                key: 'is_USA',
                render: (value) => FIELD_MAP.is_USA[value] || value,
            },
            {
                title: '路由',
                dataIndex: 'route_select',
                width: 100,
                editable: true,
                key: 'route_select',
                sorter: (a, b) => a['route_select'].localeCompare(b['route_select']),
            },
            {
                title: '是否开启',
                dataIndex: 'is_order',
                width: 100,
                editable: true,
                key: 'is_order',
                render: (value) => FIELD_MAP.is_order[value] || value,
                sorter: (a, b) => a.is_order - b.is_order,
            },
            {
                title: '限价',
                dataIndex: 'limit_price',
                width: 80,
                editable: true,
                key: 'limit_price',
                sorter: (a, b) => a['limit_price'].localeCompare(b['limit_price']),
            },
            {
                title: '直接下单',
                dataIndex: 'is_plan',
                width: 100,
                editable: true,
                key: 'is_plan',
                render: (value) => FIELD_MAP.is_plan[value] || value,
            },
            {
                title: 'is_roll',
                dataIndex: 'is_roll',
                width: 100,
                editable: true,
                key: 'is_roll',
                render: (value) => FIELD_MAP.is_roll[value] || value,
            },
            {
                title: 'CID',
                dataIndex: 'cid',
                key: 'cid',
                width: 120,
                // sorter: (a, b) => a['cid'].localeCompare(b['cid']),
            },
            {
                title: '是否开启CID',
                dataIndex: 'is_cid',
                width: 100,
                editable: true,
                key: 'is_cid',
                render: (value) => FIELD_MAP.is_cid[value] || value,
                sorter: (a, b) => a.is_order - b.is_order,
            },
            {
                title: 'CID账号',
                dataIndex: 'fake_account',
                key: 'fake_account',
                width: 120,
                // sorter: (a, b) => a?.fake_account - b?.fake_account,
            },
            {
                title: 'CID更新时间',
                dataIndex: 'update_cid_time',
                key: 'update_cid_time',
                width: 120,
                sorter: (a, b) => a['update_cid_time'].localeCompare(b['update_cid_time']),
            },
            {
                title: 'cid类型',
                dataIndex: 'cid_type',
                key: 'cid_type',
                width: 80,
                editable: true,
                render: (value) => FIELD_MAP.cid_type[value] || value,
            },
            {
                title: 'cid循环次数',
                dataIndex: 'cid_loop_times',
                width: 80,
                editable: true,
                key: 'cid_loop_times',
                sorter: (a, b) => a?.cid_loop_times - b?.cid_loop_times,
            },
            {
                title: 'cid请求次数',
                dataIndex: 'get_cid_times',
                width: 80,
                editable: true,
                key: 'get_cid_times',
                sorter: (a, b) => a?.get_cid_times - b?.get_cid_times,
            },
            {
                title: 'cid并发次数',
                dataIndex: 'cid_concurrent',
                width: 80,
                editable: true,
                key: 'cid_concurrent',
                sorter: (a, b) => a?.cid_concurrent - b?.cid_concurrent,
            },
            {
                title: 'cid间隔时间',
                dataIndex: 'cid_sleep',
                width: 80,
                editable: true,
                key: 'cid_sleep',
                sorter: (a, b) => a?.cid_sleep - b?.cid_sleep,
            },
            {
                title: 'nac循环次数',
                dataIndex: 'nac_loop_times',
                width: 80,
                editable: true,
                key: 'nac_loop_times',
                sorter: (a, b) => a?.nac_loop_times - b?.nac_loop_times,
            },
            {
                title: 'nac请求次数',
                dataIndex: 'nac_times',
                width: 80,
                editable: true,
                key: 'nac_times',
                sorter: (a, b) => a?.nac_times - b?.nac_times,
            },
            {
                title: 'nac并发次数',
                dataIndex: 'nac_concurrent',
                width: 80,
                editable: true,
                key: 'nac_concurrent',
                sorter: (a, b) => a?.nac_concurrent - b?.nac_concurrent,
            },
            {
                title: 'nac间隔时间',
                dataIndex: 'nac_sleep',
                width: 80,
                editable: true,
                key: 'nac_sleep',
                sorter: (a, b) => a?.nac_sleep - b?.nac_sleep,
            },
            {
                title: '限制天数',
                dataIndex: 'limit_day',
                editable: true,
                width: 80,
                key: 'limit_day',
                sorter: (a, b) => a?.limit_day - b?.limit_day,
            },
            {
                title: 'CID分组',
                dataIndex: 'cid_group',
                editable: true,
                width: 80,
                key: 'cid_group',
                sorter: (a, b) => a?.cid_group - b?.cid_group,
            },
            {
                title: '分组',
                dataIndex: 'group_id',
                editable: true,
                key: 'group_id',
                width: 80,
                sorter: (a, b) => a?.group_id - b?.group_id,
            },
            {
                title: '提单号',
                dataIndex: 'booking_number',
                editable: true,
                key: 'booking_number',
                width: 80,
                sorter: (a, b) => a?.booking_number - b?.booking_number,
            },
            {
                title: '操作',
                width: 80,
                dataIndex: 'operation',
                key: 'operation',
                render: (_, record) => {
                    const editable = editingKey === record.id;
                    return editable ? (
                        <Typography.Link onClick={() => save(record)}>保存</Typography.Link>
                    ) : (
                        <Typography.Link disabled={!!editingKey && editingKey !== record.id} onClick={() => edit(record)}>
                            修改
                        </Typography.Link>
                    );
                },
            },
        ],
        [editingKey],
    );
    // 过滤出当前可见的列
    const filteredColumns = useMemo(() => {
        return columns.filter((col) => visibleColumnKeys.includes(col.key));
    }, [columns, visibleColumnKeys]);

    const renderSearch = ({ current: cur, pageSize: size }) => {
        if (cur !== undefined) setPage(cur);
        if (size !== undefined) setSize(size);
        setSelectedRowKeys([]);
        let params = formSearch.getFieldsValue();
        params.per_page = size || pageSize;
        params.page = cur || current;
        ajax.get('/maersk/book/task', { params })
            .then((response) => {
                if (response.data) {
                    // response.data.forEach((item) => create(item));
                    setData(response.data);
                    setTotal(response.pagination.total);

                } else {
                    setData([]);
                }
            })
            .catch((err) => console.log(err));
    };

    const mergedColumns = useMemo(() => {
        return filteredColumns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: (record) => ({
                    record,
                    openTypeSelect: col.dataIndex === 'is_order' ? 'select' : 'text',
                    PlanSelect: col.dataIndex === 'is_plan' ? 'select' : 'text',
                    RollSelect: col.dataIndex === 'is_roll' ? 'select' : 'text',
                    openTypeUSA: col.dataIndex === 'is_USA' ? 'select' : 'text',
                    CIDTypeSelect: col.dataIndex === 'is_cid' ? 'select' : 'text',
                    CIDSelect: col.dataIndex === 'cid_type' ? 'select' : 'text',
                    inputTypeBox: col.dataIndex === 'box_type' ? 'select' : 'text',
                    inputTypeStart: col.dataIndex === 'origincity_name' ? 'select' : 'text',
                    inputTypeEnd: col.dataIndex === 'destinationcity_name' ? 'select' : 'text',
                    serviceMode: col.dataIndex === 'destination_service_mode' ? 'select' : 'text',
                    inputTypeDate: col.dataIndex === 'order_date' ? 'date' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: isEditing(record),
                    isOrderColumn: col.dataIndex === 'is_order',
                }),
            };
        });
    }, [filteredColumns, editingKey]);

    // 获取多选的id
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    // 多选
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 50,
    };

    const onMenuClick = () => {
        if (selectedRowKeys.length > 0) {
            setIsModalOpen(true);
        } else {
            message.error('请选择要修改的数据');
        }
    };

    // 批量打开
    const onMenuOpenClick = () => {
        if (selectedRowKeys.length > 0) {
            const params = {
                ids: selectedRowKeys.toString().replaceAll(',', ', '),
                is_order: 1,
            };
            ajax.post('/maersk/group/task', params)
                .then((response) => {
                    message.success('修改成功');
                    newForm.resetFields();
                    setSelectedRowKeys([]);
                    refreshList();
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            message.error('请选择要修改的数据');
        }
    };

    const getStr = (url, msg) => {
        let params = formSearch.getFieldsValue();
        let str = '';
        for (let i = 0; i < dataSource.length; i++) {
            str += dataSource[i].id + ',';
        }
        str = str.substring(0, str.lastIndexOf(','));
        if (selectedRowKeys.length > 0) {
            ajax.get(`${url}?ids=${selectedRowKeys.toString()}`)
                .then((res) => {
                    setSelectedRowKeys([]);
                    message.success(msg);
                    refreshList();
                })
                .catch((err) => {
                    console.log(err);
                });
        } else if (
            params.box_type !== undefined ||
            params.cid_group !== undefined ||
            params.destinationcity_name !== undefined ||
            params.group_id !== undefined ||
            params.list_type !== undefined ||
            params.order_id !== undefined ||
            params.origincity_name !== undefined
        ) {
            ajax.get(`${url}?ids=${str}`)
                .then((res) => {
                    message.success(msg);
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            ajax.get(`${url}`)
                .then((res) => {
                    message.success(msg);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    // 关闭初始化
    const closeInitialization = () => {
        getStr('/delay/cid', '关闭初始化成功');
    };

    // 清除路由
    const clearRouter = () => {
        getStr('/delay/route', '清除路由成功');
    };

    const handleOk = () => {
        const prm = newForm.getFieldsValue();
        prm.cid_loop_times = prm.cid_loop_times ? Number(prm.cid_loop_times) : undefined;
        prm.cid_concurrent = prm.cid_concurrent ? Number(prm.cid_concurrent) : undefined;
        prm.get_cid_times = prm.get_cid_times ? Number(prm.get_cid_times) : undefined;
        prm.ids = selectedRowKeys.toString().replaceAll(',', ', ');
        if (Array.isArray(prm.quantity)) {
            prm.quantity = prm.quantity.join(',');
        }
        if (Array.isArray(prm.box_type)) {
            prm.box_type = prm.box_type.join(',');
        }
        ajax.post('/maersk/group/task', prm)
            .then(() => {
                message.success('修改成功');
                newForm.resetFields();
                setSelectedRowKeys([]);
                setIsModalOpen(false);
                refreshList();
            })
            .catch((err) => console.log(err));
    };

    const handleCancel = () => {
        newForm.resetFields();
        setSelectedRowKeys([]);
        setIsModalOpen(false);
    };

    const onShowSizeChange = (row) => {
        renderSearch(row);
    };

    const newOnChange = (val) => {
        newForm.setFieldsValue({
            order_date: dayjs(val).format('YYYY-MM-DD'),
        });
    };

    return (
        <div className="list">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    <PageHeader title="task列表" sticky></PageHeader>

                    <Col style={{ display: 'flex', justifyContent: 'space-around', gap: 12, alignItems: 'center' }}>
                        <Popconfirm
                            title="确认"
                            description="确认关闭初始化吗?"
                            okText="是"
                            onConfirm={closeInitialization}
                            cancelText="否"
                        >
                            <Button type="primary">关闭初始化</Button>
                        </Popconfirm>
                        <Popconfirm title="确认" description="确认清除路由吗?" okText="是" onConfirm={clearRouter} cancelText="否">
                            <Button type="primary">清除路由</Button>
                        </Popconfirm>
                        <Button type="primary" onClick={() => onMenuClick()}>
                            批量修改
                        </Button>
                        <Button type="primary" onClick={() => onMenuOpenClick()}>
                            批量打开
                        </Button>
                        <Popover
                            trigger="click"
                            open={columnSettingVisible}
                            onOpenChange={setColumnSettingVisible}
                            content={
                                <div style={{ width: 260 }}>
                                    <div style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
                                        <Button size="small" onClick={() => updateVisibleColumns(ALL_COLUMN_KEYS)}>
                                            全选
                                        </Button>
                                        <Button size="small" onClick={() => updateVisibleColumns([])}>
                                            全不选
                                        </Button>
                                    </div>
                                    <Checkbox.Group
                                        value={visibleColumnKeys}
                                        onChange={(checkedValues) => updateVisibleColumns(checkedValues)}
                                        style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
                                    >
                                        {ALL_COLUMN_KEYS.map((key) => {
                                            // 需要根据 key 找到对应的列标题
                                            const col = columns.find((c) => c.key === key);
                                            if (!col) return null;
                                            return (
                                                <Checkbox key={key} value={key}>
                                                    {col.title}
                                                </Checkbox>
                                            );
                                        })}
                                    </Checkbox.Group>
                                </div>
                            }
                            title="列设置"
                        >
                            <Button >列设置</Button>
                        </Popover>
                    </Col>
                </div>
            </div>
            <Card style={{ width: '100%' }} className="ax-search-card">
                <Form form={formSearch} autoComplete="off">
                    <Row gutter={SEARCH_ITEM_GUTTER}>
                        <Col style={{ width: '13%' }}>
                            <Form.Item label="对应taskID" name="order_id">
                                <Input style={{ width: '80%' }}></Input>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '17%' }}>
                            <Form.Item label="起始港" name="origincity_name">
                                <Select
                                    options={createJsonOptions(startPortOptions)}
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '17%' }}>
                            <Form.Item label="目的港" name="destinationcity_name">
                                <Select
                                    options={createJsonOptions(endPortOptions)}
                                    showSearch
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ display: 'flex', width: '30%' }}>
                            <Form.Item style={{ width: '50%', marginRight: '5%' }} label="箱型" name="box_type">
                                <Select
                                    options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                            <Form.Item label="CID分组" name="cid_group">
                                <Input style={{ width: '70%' }}></Input>
                            </Form.Item>
                            <Form.Item label="分组" name="group_id">
                                <Input style={{ width: '70%' }}></Input>
                            </Form.Item>

                        </Col>

                        <Col style={{ display: 'flex' }}>

                            <Form.Item label="列表分组" name="list_type">
                                <Input style={{ width: '60%' }}></Input>
                            </Form.Item>
                            <span style={{ width: '40%', marginLeft: '10%' }}>
                                <Button onClick={() => renderSearch({ current: 1 })} type="primary">
                                    搜索
                                </Button>
                            </span>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Modal title="" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} closable={false}>
                <Form form={newForm} style={{ width: '80%', margin: '0 auto' }}>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item label="对应taskID" name="order_id">
                                <Input />
                            </Form.Item>
                        </Col>
                        {/* <Col span={24}>
                            <Form.Item label="添加taskID" name="order_id_add">
                                <Input />
                            </Form.Item>
                        </Col> */}
                        <Col span={24}>
                            <Form.Item label="账户" name="account_name">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="数量" name="quantity">
                                <Select
                                    mode="tags"
                                    tokenSeparators={[',', ' ', '\n']}
                                    maxTagCount={1}
                                    onKeyDown={(e) => {
                                        const key = e.key;
                                        if (
                                            !/^[0-9]$/.test(key) &&
                                            key !== 'Backspace' &&
                                            key !== 'Delete' &&
                                            key !== 'ArrowLeft' &&
                                            key !== 'ArrowRight' &&
                                            key !== 'Tab' &&
                                            key !== 'Enter' &&
                                            key !== ',' &&
                                            key !== ' ' &&
                                            key !== ';'
                                        ) {
                                            e.preventDefault();
                                        }
                                    }}
                                    onPaste={(e) => e.preventDefault()}
                                    onChange={(value) => {
                                        // 过滤非数字的标签
                                        const filtered = value.filter((v) => /^\d+$/.test(v));
                                        if (filtered.length !== value.length) {
                                            // 使用 setTimeout 避免与 Ant Design 内部状态冲突
                                            setTimeout(() => {
                                                newForm.setFieldsValue({ quantity: filtered });
                                            }, 0);
                                        }
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <div>
                                <Form.Item label="箱型" name="box_type">
                                    <Select
                                        mode="multiple"
                                        style={{ width: 140 }}
                                        options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                                        showSearch
                                        allowClear
                                        placeholder="请选择箱型（可多选）"
                                        maxTagCount={1}
                                    />
                                </Form.Item>
                            </div>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="起始港" name="origincity_name">
                                <Select style={{ width: 320 }} options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="目的港" name="destinationcity_name">
                                <Select style={{ width: 320 }} options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="目的港类型" name="destination_service_mode">
                                <Select options={createJsonOptions(['CY', 'SD'])} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col span={16}>
                            <Form.Item label="搜索开航日" name="order_date">
                                <Space direction="vertical">
                                    <DatePicker onChange={newOnChange} format="YYYY-MM-DD" />
                                </Space>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="路由" name="route_select">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="是否开启" name="is_order">
                                <Select
                                    style={{ width: 100 }}
                                    options={[
                                        { label: '开启', value: 1 },
                                        { label: '关闭', value: 0 },
                                    ]}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="限价" name="limit_price">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="直接下单" name="is_plan">
                                <Select
                                    options={[
                                        { label: '是', value: 1 },
                                        { label: '否', value: 0 },
                                    ]}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="is_roll" name="is_roll">
                                <Select
                                    options={[
                                        { label: '是', value: 1 },
                                        { label: '否', value: 0 },
                                    ]}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="美线" name="is_USA">
                                <Select
                                    options={[
                                        { label: '是', value: 1 },
                                        { label: '否', value: 0 },
                                    ]}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="是否开启CID" name="is_cid">
                                <Select
                                    style={{ width: 100 }}
                                    options={[
                                        { label: '关闭', value: 0 },
                                        { label: '常规初始化', value: 1 },
                                        { label: '加载更多初始化', value: 2 },
                                        { label: '3', value: 3 },
                                        { label: '4', value: 4 },
                                    ]}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="限制天数" name="limit_day">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="CID分组" name="cid_group">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="分组" name="group_id">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="cid类型" name="cid_type">
                                {/* <Select
                                    style={{ width: 100 }}
                                    options={[
                                        { label: '常规下单', value: 0 },
                                        { label: '模式下单', value: 1 },
                                        { label: '模式下单2', value: 2 },
                                        { label: '模式下单3', value: 3 },
                                        { label: '模式下单4', value: 4 },
                                    ]}
                                    filterable
                                    allow-create
                                    showSearch
                                    allowClear
                                ></Select> */}
                                <LabelValueAutoComplete
                                    style={{ width: '100%' }}
                                    options={cidTypeOptions}
                                    placeholder="选择或输入"
                                    allowClear
                                    showSearch
                                />

                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="cid循环次数" name="cid_loop_times">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="cid请求次数" name="get_cid_times">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="cid并发次数" name="cid_concurrent">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="cid间隔时间" name="cid_sleep">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="nac循环次数" name="nac_loop_times">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="nac请求次数" name="nac_times">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="nac并发次数" name="nac_concurrent">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="nac间隔时间" name="nac_sleep">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="提单号" name="booking_number">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="是否重复添加" name="is_add_data">
                                <Select
                                    style={{ width: 100 }}
                                    options={[
                                        { label: '是', value: 1 },
                                        { label: '否', value: 0 },
                                    ]}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>

            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    rowSelection={rowSelection}
                    rowKey={(record) => record.id}
                    bordered
                    dataSource={dataSource}
                    virtual
                    // columns={mergedColumns}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        defaultPageSize: 100,
                        current: current,
                        pageSizeOptions: [10, 15, 25, 50, 100, 200, 500, 1000],
                        showTotal: (total) => `共 ${total} 条`,
                    }}
                    onChange={onShowSizeChange}
                    scroll={{ y: tableScrollY }}
                />
            </Form>
        </div>
    );
}
